module.exports = __webpack_public_path__ + "img/empty.86212464.svg";